import React, { Component } from 'react';
import { faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TicketBox from './TicketBox';
import TicketBoxStyle from './TicketBoxStyle';
import IconTicketHistory from '../../assets/icons/IconTicketHistory';
import IconTicketHistorySecond from '../../assets/icons/IconTicketHistorySecond';
import IconTicketLate from '../../assets/icons/IconTicketLate';
import IconTicketUser from '../../assets/icons/IconTicketUser';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';

class TicketBoxListCSO extends Component {
    filterStatus = status => {
        const filtered = this.props.data.filter((ticket) => ticket.status === status);
        return filtered.length;
    };

    filterDataTracker = status => {
        if (status === 'overdue') {
            const filtered = this.props.data.filter((ticket) => ticket.is_locked === true);
            return filtered.sort((a, b) => b.ticket_no.localeCompare(a.ticket_no));
        }

        const filtered = this.props.data.filter((ticket) => ticket.status === status);
        return filtered.sort((a, b) => b.ticket_no.localeCompare(a.ticket_no));
    }

    render() {
        return (
            <>
                {/* Dashboard Ticket box */}
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnunassigned" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.UNASSIGNED))} titleTicket="unassigned" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.UNASSIGNED)} iconTicket={<IconTicketHistory />} textColor="text-nexcarered1" iconBoxColor="bg-nexcarered1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnassigned" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.ASSIGNED))} titleTicket="assigned" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.ASSIGNED)} iconTicket={<IconTicketUser />} textColor="text-nexcareblue2" iconBoxColor="bg-nexcareblue2" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btninprogress" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.IN_PROGRESS))} titleTicket="in progress" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.IN_PROGRESS)} iconTicket={<IconTicketHistorySecond />} textColor="text-nexcareorange1" iconBoxColor="bg-nexcareorange1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnonhold" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.ON_HOLD))} titleTicket="on hold" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.ON_HOLD)} iconTicket={<IconTicketHistorySecond />} textColor="text-nexcareblue1" iconBoxColor="bg-nexcareblue1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnoverdueticket" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker('overdue'))} titleTicket="tiket terlambat" totalTicket={this.props.data.filter((ticket) => ticket.is_locked === true).length} iconTicket={<IconTicketLate />} textColor="text-nexcareorange3" iconBoxColor="bg-nexcareorange3" />
                </div>
                <div className="rounded-md shadow-lg h-32 bg-lightyellow relative col-span-2">
                    <TicketBoxStyle
                        loading={this.props.loading}
                        textColor="text-blue-800"
                        iconTitle={<FontAwesomeIcon icon={faHandHoldingDollar} className="fa-xl" />}
                        titleTicket="total komisi" totalTicket={this.props.commissionData.commission?.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' }) ? this.props.commissionData.commission?.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' }) : '0'} boxIconColor="#FDDB74" />
                </div>
            </>
        );
    }
}

export default TicketBoxListCSO;